import { render, staticRenderFns } from "./DateSingle.vue?vue&type=template&id=60b37d3a&scoped=true&"
import script from "./DateSingle.vue?vue&type=script&lang=js&"
export * from "./DateSingle.vue?vue&type=script&lang=js&"
import style0 from "./DateSingle.vue?vue&type=style&index=0&id=60b37d3a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b37d3a",
  null
  
)

export default component.exports